export const ProviderTableCellName = {
  Address: 'address',
  Building: 'buildings',
  Category: 'categories',
  Created: 'created',
  CreatedBy: 'created_by',
  Description: 'description',
  Email: 'email',
  ExternalId: 'external_id',
  Name: 'name',
  OrderEmail: 'order_email',
  OrderPhone: 'order_phone',
  Phone: 'phone',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
  Website: 'website',
  WorkingHours: 'working_hours',
}
